export default function handleTextChange(event, setData) {
    const textKey = event.target.value;
    console.log(textKey, 'handleTect');
    setData(textKey);
}
